export default __webpack_public_path__ + "static/media/facebook.8ac00293.png";